(() => {
  angular
    .module('gm.common.directives')
    .directive('gmLabelFor', gmLabelForDirective);

  function gmLabelForDirective(
    $document
  ) {
    'ngInject';

    return {
      restrict: 'A',

      link(scope, element, attrs, _ctrl) {
        function clickHandler() {
          $document
            .find(`#${attrs.gmLabelFor}`)
            .focus();
        }

        element.on('click', clickHandler);

        scope.$on('$destroy', () => {
          element.off('click', clickHandler);
        });
      },
    };
  }
})();
